export class LoginViewModel {

  public userName: string;
  public password: string;
  public returnurl: string;
  public refreshToken: string;
  public grantType: string;
  public rememberMe: boolean;
  public userId: string;
  public accountName: string;
  public accountId: string;
  public laboratoryId: string;
  public distributorId: string;
  public labGroupId: string;
  public loginAsGlobal: boolean = false;
}
